export default "__VITE_ASSET__f745ce1c__"